import { Link, useLocation } from "react-router-dom";
import { useCart } from "@/lib/cart";
import { useState, useEffect } from "react";

export default function Nav() {
  const { count } = useCart();
  const loc = useLocation();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const linkCls = (path) =>
    `overline transition-colors ${loc.pathname === path ? "text-[#EAEAEA]" : "text-[#888] hover:text-[#EAEAEA]"}`;

  return (
    <nav
      data-testid="main-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "backdrop-blur-xl bg-[#030303]/80 border-b border-[#1A1A1A]" : "bg-transparent"
      }`}
    >
      <div className="flex items-center justify-between px-6 md:px-10 py-5">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3">
          <img
            src="https://customer-assets-cm19k8pv.emergentagent.net/job_degoogled-oz/artifacts/c5gb5oy4_masked-hooded-ninja-assassin-warrior-emblem-vector-51649204%20%281%29.webp"
            alt="Phantom Phone"
            className="h-9 w-auto invert"
            style={{ filter: "invert(1)" }}
          />
          <span className="font-phantom text-[18px] tracking-[0.06em] uppercase">Phantom <span className="text-[#7C3AED]">Phone</span></span>
        </Link>
        <div className="hidden md:flex items-center gap-10">
          <Link to="/shop" className={linkCls("/shop")} data-testid="nav-shop">Devices</Link>
          <Link to="/compare" className={linkCls("/compare")} data-testid="nav-compare">Compare</Link>
          <Link to="/hardening" className={linkCls("/hardening")} data-testid="nav-hardening">Hardening</Link>
          <Link to="/manifesto" className={linkCls("/manifesto")} data-testid="nav-manifesto">Manifesto</Link>
          <Link to="/orders" className={linkCls("/orders")} data-testid="nav-orders">Track</Link>
          <Link to="/contact" className={linkCls("/contact")} data-testid="nav-contact">Contact</Link>
        </div>
        <div className="flex items-center gap-6">
          <span className="overline hidden lg:inline">SYDNEY · AU</span>
          <Link to="/cart" className="overline text-[#EAEAEA] flex items-center gap-2" data-testid="nav-cart">
            <span>Cart</span>
            <span className="border border-[#333] px-2 py-0.5 text-[10px]" data-testid="cart-count">{count.toString().padStart(2, "0")}</span>
          </Link>
        </div>
      </div>
    </nav>
  );
}
